// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Toastr, Button } from "@revvsales/components";

// Components Imports
import { EmptyScreen } from "../../../commonComponents";
import AssetsOpportunity from "../AssetsOpportunity";
import AddOpportunity from "../../AddOpportunity";

// Actions Imports
import { getAssetsByAccount } from "../../../actions/AssetsActions/assetsActions";

// Internal Imports
import AssetsOppEmptyImageSrc from "../../../assets/No-opportunity.png";
import { GlobalUtils, OppoUtils } from "../../../utils";
import { PIPELINE } from "../../../constants";

// Destructuring
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;
const { sortOppsDocs } = OppoUtils;

class AssetsDetails extends Component {
  state = { showLoader: false };

  componentDidMount() {
    this._toggleLoader(true);
    this.props
      .getAssetsByAccount(this.props.accountID)
      .then(response => {
        this._toggleLoader(false);
        return response;
      })
      .catch(error => {
        console.error(`AssetsDetails => componentDidMount => ${error}`);
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  }

  componentDidUpdate(prevProps) {
    if (this.props.accountID !== prevProps.accountID) {
      this._toggleLoader(true);
      this.props
        .getAssetsByAccount(this.props.accountID)
        .then(response => {
          this._toggleLoader(false);
          return response;
        })
        .catch(error => {
          console.error(`AssetsDetails => componentDidUpdate => ${error}`);
          this._toggleLoader(false);
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(error),
            timeout: 3000,
          });
        });
    }
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _toggleAddOppoPopup = state => {
    this.setState({ showAddOppoPopup: state });
  };

  _decideAssetDetailsView = () => {
    if (this.state.showLoader) {
      return <Loader />;
    }
    return this.props.accountDocs.length > 0 ? (
      <div className="assetsdetails-body-wrapper">
        <div className="assetsdetails-opportunitieslist-wrapper">
          <div className="assetsdetails-oppslist-container">
            <div className="assets-opportunities-tableheading">
              <div className="assetstable-doc-title">
                <span>Opportunity</span>
              </div>
              <div className="assetstable-doc-type">
                <span>Doc Type</span>
              </div>
              {/* <div className="assetstable-doc-id">
                  <span>Doc Id</span>
                </div>
                <div className="assetstable-doc-startdate">
                  <span>Start Date</span>
                </div> */}
              <div className="assetstable-doc-owner">
                <span>Owner</span>
              </div>
              <div className="assetstable-doc-enddate">
                <span>Turn Around Date</span>
              </div>
              <div className="assetstable-doc-lastedit">
                <span>Last Edited</span>
              </div>
              <div className="assetstable-doc-status">
                <span>Status</span>
              </div>
            </div>

            {sortOppsDocs(
              this.props.accountDocs,
              PIPELINE.BY_LAST_UPDATE,
              false,
            ).map(opportunityAssets => (
              <AssetsOpportunity
                key={opportunityAssets.crm_opportunity.id}
                {...opportunityAssets}
                selectedAccount={this.props.selectedAccount}
                documentTypes={this.props.documentTypes}
                history={this.props.history}
              />
            ))}
          </div>
        </div>
      </div>
    ) : (
      <EmptyScreen
        imageSrc={AssetsOppEmptyImageSrc}
        message="No opportunities created for this Account!"
      />
    );
  };

  render() {
    return (
      <Fragment>
        {this.state.showAddOppoPopup && (
          <AddOpportunity
            accountPreSelected
            accountID={this.props.accountID}
            toggleAddOppoPopup={this._toggleAddOppoPopup}
            showAddOppoPopup={this.state.showAddOppoPopup}
            accounts={this.props.accounts}
          />
        )}
        <div className="pipelineoppurtunity-heading-wrapper assets-rightwrapper-heading">
          <div className="pipelineoppurtunity-heading-container">
            <div className="pipelineoppurtunity-heading">
              <span className="assets-heading-icon">
                <FontAwesomeIcon icon={["far", "briefcase"]} />
              </span>
              <div className="pipelineoppurtunity-heading-info">
                <div className="pipelineoppurtunity-heading-title">
                  {this.props.selectedAccount
                    ? this.props.selectedAccount.name
                    : null}
                </div>
                <div className="pipelineoppurtunity-heading-meta">
                  {this.props.accountDocs
                    ? `${this.props.accountDocs.length} `
                    : null}
                  Opportunities
                </div>
              </div>
            </div>
            <div className="pipelineoppurtunity-meta">
              <ul>
                <li>
                  <h5>City</h5>
                  <h3>
                    {this.props.selectedAccount
                      ? this.props.selectedAccount.detailed_address.city || "-"
                      : null}
                  </h3>
                </li>
                <li>
                  <h5>State</h5>
                  <h3>
                    {this.props.selectedAccount
                      ? this.props.selectedAccount.detailed_address.state || "-"
                      : null}
                  </h3>
                </li>
              </ul>
            </div>
            {!readDataFromLocalStorage("revvsalesUser").crm_configured && (
              <div className="add-new-opportunity">
                <Button
                  className="revv-btn-secondary"
                  disabled={this.state.disableAdd}
                  onClick={() => this._toggleAddOppoPopup(true)}
                  data-test="assetsdetails-add-opportunity-btn">
                  <i>
                    <FontAwesomeIcon icon={["far", "plus"]} />
                  </i>
                  Add New Opportunity
                </Button>
              </div>
            )}
          </div>
        </div>

        {this._decideAssetDetailsView()}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    selectedAccount,
    accountDocs,
    accountGlobalDocs,
    accounts,
    documentTypes,
  } = state.OldAssetStore;
  return {
    selectedAccount,
    accountDocs,
    accountGlobalDocs,
    accounts,
    documentTypes,
  };
};

const mapDispatchToProps = {
  getAssetsByAccount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetsDetails);



// WEBPACK FOOTER //
// ./src/components/AssetsWrapper/AssetsDetails/index.js